(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDeleteController',TabObjectsDeleteController);

    TabObjectsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabObjects'];

    function TabObjectsDeleteController($uibModalInstance, entity, TabObjects) {
        var vm = this;
        vm.tabObjects = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabObjects.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
